import React, { createContext, useState, useEffect } from 'react'
import { PlayerWithContract, fetchAllPlayersWithContract } from '../../Api'
import { CURRENT_YEAR } from '../../Config/League/league.config'

type LeagueContractsContextType = {
  players: PlayerWithContract[]
  loading: boolean
}

export const LeagueContractsContext = createContext<LeagueContractsContextType | null>(
  null
)

export const LeagueContractsProvider: React.FC<React.PropsWithChildren<unknown>> = ({
  children,
}) => {
  const [players, setPlayers] = useState<PlayerWithContract[]>([])
  const [loading, setLoading] = useState<boolean>(true)

  useEffect(() => {
    getLeagueContracts()
  }, [])

  const getLeagueContracts = async (): Promise<void> => {
    try {
      const playerRes = await fetchAllPlayersWithContract(CURRENT_YEAR, 'current')
      if (!playerRes?.allPlayers || playerRes.allPlayers.length < 1) {
        setLoading(false)
        return
      }
      const plrs = playerRes.allPlayers.filter(
        (pl) => pl.currentTeam?.officialId !== 'ZPP' && pl.contractStatus
      )
      setPlayers(plrs)
      setLoading(false)
    } catch (err) {
      setLoading(false)
      console.error(err)
    }
  }

  return (
    <LeagueContractsContext.Provider
      value={{
        players: players,
        loading: loading,
      }}
    >
      {children}
    </LeagueContractsContext.Provider>
  )
}
